const Builder = require('../BuilderBase');

module.exports = class DatePicker extends Builder {
    constructor(title, properties) {
        super('formElement_DatePicker', title, properties);
    }
};
